import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import { Home } from './pages/Home';
import { SSIAP } from './pages/SSIAP';
import { SSIAP1Page } from './pages/SSIAP1Page';
import { SSIAP2Page } from './pages/SSIAP2Page';
import { SSIAP3Page } from './pages/SSIAP3Page';
import { SSIAP1in } from './pages/SSIAP1in';
import { SSIAP1rec } from './pages/SSIAP1rec';
import { SSIAP1ran } from './pages/SSIAP1ran';
import { SSIAP2in } from './pages/SSIAP2in';
import { SSIAP2rec } from './pages/SSIAP2rec';
import { SSIAP2ran } from './pages/SSIAP2ran';
import { SSIAP3in } from './pages/SSIAP3in';
import { SSIAP3rec } from './pages/SSIAP3rec';
import { SSIAP3ran } from './pages/SSIAP3ran';
import { APS } from './pages/APS';
import { APSin } from './pages/APSin';
import { APSmac } from './pages/APSmac';
import {SST} from './pages/SST';
import {SSTin} from './pages/SSTin';
import {SSTmac} from './pages/SSTmac';
import {HOBO} from './pages/HOBO';
import { Contact } from './pages/Contact';
import { MentionLegal } from './pages/MentionLegal';
import { ConditionsGeneralsUsers } from './pages/ConditionsGeneralsUsers';
import { ConditionsGeneralsVente } from './pages/ConditionsGeneralsVente';

export const Paths = () => {
    return(
        <Router>
            <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path="/SSIAP" element={<SSIAP />} />
                <Route exact path="/SSIAP1Page" element={<SSIAP1Page />} />
                <Route exact path="/SSIAP2Page" element={<SSIAP2Page />} />
                <Route exact path="/SSIAP3Page" element={<SSIAP3Page />} />
                <Route exact path="/SSIAP1in" element={<SSIAP1in />} />
                <Route exact path="/SSIAP1rec" element={<SSIAP1rec />} />
                <Route exact path="/SSIAP1ran" element={<SSIAP1ran />} />
                <Route exact path="/SSIAP2in" element={<SSIAP2in />} />
                <Route exact path="/SSIAP2rec" element={<SSIAP2rec />} />
                <Route exact path="/SSIAP2ran" element={<SSIAP2ran />} />
                <Route exact path="/SSIAP3in" element={<SSIAP3in />} />
                <Route exact path="/SSIAP3rec" element={<SSIAP3rec />} />
                <Route exact path="/SSIAP3ran" element={<SSIAP3ran />} />
                <Route exact path="/APS" element={<APS />} />
                <Route exact path="/APSin" element={<APSin />} />
                <Route exact path="/APSmac" element={<APSmac />} />
                <Route exact path="/SST" element={<SST />} />
                <Route exact path="/SSTin" element={<SSTin />} />
                <Route exact path="/SSTmac" element={<SSTmac />} />
                <Route exact path="/HOBO" element={<HOBO />} />
                <Route exact path="/Contact" element={<Contact />} />
                <Route exact path="/MentionLegal" element={<MentionLegal />} />
                <Route exact path="/ConditionsGeneralsVente" element={<ConditionsGeneralsVente />} />
                <Route exact path="/ConditionsGeneralsUsers" element={<ConditionsGeneralsUsers />} />
            </Routes>
        </Router>
    );
}